import { longSearchInBody, insertTextAtCursor } from '@Service/wordApiService';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import { DOCUMENT_SEARCH, DOCUMENT_CONTENT_CONTROL, NOTIFICATION_HANDLER } from '@Constants/types';
import store from '@Store';
import mixpanelEvents from '@Mixpanel';

// Navigate functionality
export function navigateTextInBody(text, inputLocation, navigateIndex = 0) {
    return dispatch => {
        dispatch({
            type: DOCUMENT_SEARCH.SEARCH_REQUEST,
            payload: inputLocation
        });

        navigateTextHandler(text, null, navigateIndex, text);
    };
}

function navigateTextHandler(input, searchResults, navigateIndex, originalText) {
    try {
        if (searchResults == null) {
            longSearchInBody(
                input,
                res => navigateTextHandler(input, res, navigateIndex, originalText),
                // true,
                originalText
            );
            return;
        }

        if (searchResults.items.length > 0) {
            // found something
            if (typeof searchResults.items[navigateIndex] === 'undefined') {
                // jumpTo the found text
                store.dispatch({ type: DOCUMENT_SEARCH.SEARCH_INDEX_CLEAR });
                searchResults.items[0].select();
            } else {
                // jumpTo the next found text in the list
                searchResults.items[navigateIndex].select();
            }

            store.dispatch({ type: DOCUMENT_SEARCH.SEARCH_SUCCESS });
            mixpanelEvents.ruleCardClickedShowOnDocument();
        } else if (input.length > 50) {
            // not found, try a small search string
            const reducedInput = input.substring(0, input.length - 25);
            longSearchInBody(
                reducedInput,
                res => navigateTextHandler(reducedInput, res, navigateIndex),
                // true,
                originalText
            );
        } else {
            // not found
            store.dispatch({ type: DOCUMENT_SEARCH.SEARCH_FAILURE });
        }
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'wordApiActions.navigateTextHandler', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
    }
}

// ContentControl Functionality
export function addContentControl(
    text,
    textLocation,
    contentControlOptions = { title: '', color: '#FFFF00' }
) {
    try {
        let modifiedText = text.split(' ').join('?');
        modifiedText = modifiedText.substring(0, 255);
        modifiedText = replaceSpecialCharacters(modifiedText);
        return dispatch => {
            dispatch({
                type: DOCUMENT_CONTENT_CONTROL.CREATE_REQUEST,
                payload: {
                    text: {
                        original: text,
                        modified: modifiedText
                    },
                    textLocation,
                    contentControlOptions
                }
            });
            contentControlHandler(modifiedText, null, textLocation, contentControlOptions);
        };
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'wordApiActions.addContentControl', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
        return null;
    }
}

function contentControlHandler(input, searchResults, textLocation, contentControlOptions) {
    try {
        if (searchResults == null) {
            longSearchInBody(
                input,
                res => contentControlHandler(input, res, textLocation, contentControlOptions),
                2,
                true
            );
            return;
        }

        if (searchResults.items.length > 0) {
            // TODO: What about rest of searchResults
            const contentControl = searchResults.items[0].insertContentControl();
            contentControl.title = contentControlOptions.title;
            contentControl.color = contentControlOptions.color;
            contentControl.tag = textLocation.tag;
            contentControl.removeWhenEdited = true;
            contentControl.appearance = 'Tags';

            store.dispatch({
                type: DOCUMENT_CONTENT_CONTROL.CREATE_SUCCESS,
                payload: { controlTag: textLocation.tag, searchResults }
            });
        } else if (input.length > 50) {
            const reducedInput = input.substring(0, input.length - 25);
            longSearchInBody(
                reducedInput,
                res =>
                    contentControlHandler(reducedInput, res, textLocation, contentControlOptions),
                2,
                true
            );
        } else {
            store.dispatch({ type: DOCUMENT_CONTENT_CONTROL.CREATE_FAILURE });
        }
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'wordApiActions.contentControlHandler', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
    }
}

/* Insert clause text at cursor position */
export default function insertTextAtCursorPosition(text) {
    try {
        insertTextAtCursor(text);
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'wordApiActions.insertTextAtCursorPosition', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
    }
}

/* Replace all the special characters with a '?' character */
function replaceSpecialCharacters(input) {
    try {
        let modifiedInput = '';
        const specialCharacters = ['[', ']', '(', ')', '{', '}', '*', '?', '<', '>', '!', '@'];
        [...input].forEach(c => {
            if (specialCharacters.includes(c)) {
                modifiedInput = `${modifiedInput}?`;
            } else {
                modifiedInput = `${modifiedInput}${c}`;
            }
        });

        return modifiedInput;
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'wordApiActions.replaceSpecialCharacters', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
        return input;
    }
}
